const wowApp = require('angular').module('wowApp.shop');

wowApp.service('SavedCardService', ['Restangular', require('./saved-card-service')]);

wowApp.directive('wowSaveCard', ['SavedCardService', require('./save-card-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/savedcard/index.js
 **/